/* eslint-disable sort-keys-fix/sort-keys-fix */

import base from "./base"
import type { CommunityData } from "./types"

/**
 * Minimal community config for FleaMarket
 * Only needed for checkout routing - inherits base styles
 */
const fleamarket: CommunityData = {
  code: "fleamarket",
  inviteCode: "fleamarket",
  name: "WERZ Flea Market",
  thumbnail: "",
  favicon: "",
  url: "/c/fleamarket",
  socials: {},
  defaultCurrency: "SEK",
  styles: base.styles,
}

export default fleamarket
